export default __webpack_public_path__ + "static/media/delivery_in_progress.7ece88e3.png";